class LoginDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#LoginDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderLoginAccessibility();
    }

    setHeaderLoginAccessibility() {
        const headerLoginLink = document.querySelector('#login-drawer-btn');
        const ambassadorLoginLink = document.querySelector('#ambassador-login-drawer-btn');

        [headerLoginLink, ambassadorLoginLink].forEach((loginLink) => {
            if (!loginLink) {
                return;
            }
            loginLink.setAttribute('role', 'button');
            loginLink.setAttribute('aria-haspopup', 'dialog');
            loginLink.addEventListener('click', (event) => {
                event.preventDefault();
                this.open(loginLink);
            });
            loginLink.addEventListener('keydown', (event) => {
                if (event.code.toUpperCase() === 'SPACE') {
                    event.preventDefault();
                    this.open(loginLink);
                }
            });
        })
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);

        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = document.getElementById('LoginDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            }, {
                once: true
            }
        );

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('login-drawer', LoginDrawer);